import { z } from 'zod';

/**
 * The two directions any sortable column can be read in.
 *
 * @since 1.4.0
 */
export const SORT_DIRECTIONS = ['asc', 'desc'] as const;

export const sortDirectionSchema = z.enum(SORT_DIRECTIONS);

export type SortDirection = z.infer<typeof sortDirectionSchema>;

/**
 * Builds the sort half of a list query for an endpoint sortable on a known set of columns.
 * The keys are the column keys the table renders, so the app never has to translate a
 * header into a database column name.
 *
 * @since 1.4.0
 * @param keys - the column keys this endpoint accepts
 * @param defaultKey - the column the endpoint sorts on when the query names none
 * @param defaultDirection - the direction the endpoint uses when the query names none
 * @returns a schema carrying a validated `sort` and `dir`
 */
export function sortQuerySchema<const TKeys extends readonly [string, ...string[]]>(
    keys: TKeys,
    defaultKey: TKeys[number],
    defaultDirection: SortDirection,
) {
    return z.object({
        sort: z.enum(keys).default(defaultKey),
        dir: sortDirectionSchema.default(defaultDirection),
    });
}
